.h5 {
  display: inline-block;
  font-size: 14px;
  line-height: 1.85;
  color: var(--color-easil-black);
}
